import PropTypes from 'prop-types';

import responsiveImagePropType from './responsiveImagePropType';

export default PropTypes.shape({
  image: responsiveImagePropType.isRequired,
  slug: PropTypes.string,
  title: PropTypes.string.isRequired,
});
